import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import { Box, Grid, Tabs, Tab, Slider, Stack } from '@mui/material/';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ApiData } from '../../data/apiData';
import ProgressLine from '../ProgressLine';
import { Dropdown } from 'primereact/dropdown';
import getRequest from '../../assets/helper/ApiHandler';
import { useNavigate } from 'react-router-dom';
import Loader from '../SpinnyLoader/Loader';
import { useSelector } from 'react-redux';


function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const marks = [
    {
        value: 0,
        label: '$1.234',
    },
    {
        value: 50,
        label: '$1.863',
    },
    {
        value: 100,
        label: '$2.863',
    },
];

const schain = [
    {
        node: 1,
        domain: 'example.com'
    },
    {
        node: 2,
        domain: 'unruly.com'
    }
]
export default function PopupContent({ PerformanceLabel1, PerformanceLabel2, demandAlignment, supplyAlignment, selectedRowId }) {
    const [value, setValue] = React.useState(0);
    const [progress, setProgress] = React.useState(0);
    const [dates, setDates] = useState({
        startDate: useSelector(state => state.dateRange.startDate),
        endDate: useSelector(state => state.dateRange.endDate)
    });

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    // const [demandAlignment, setDemandAlignment] = useState([]);
    // const paginatorLeft = <Button type="button" icon="pi pi-refresh" text />;
    // const paginatorRight = <Button type="button" icon="pi pi-download" text />;

    const paginatorTemplate = {
        layout: 'RowsPerPageDropdown CurrentPageReport NextPageLink PrevPageLink',
        RowsPerPageDropdown: (options) => {
            const dropdownOptions = [
                { label: 5, value: 5 },
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 120, value: 120 }
            ];

            return (
                <React.Fragment>
                    <div className='paginatorLeft'>
                        <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>
                            Rows per page {' '}
                        </span>
                        <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                    </div>
                </React.Fragment>
            );
        },
        CurrentPageReport: (options) => {
            return (
                <div className='paginatorRight'>
                    <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                        Pages {options.first} of {options.totalRecords}
                    </span>
                </div>
            );
        }
    };

    useEffect(() => {
        fetchSupplyPanelDetails();
    }, []);
    const navigate = useNavigate();
    const [deviceData, setDeviceData] = useState([]);
    const [geoData, setGeoData] = useState([]);
    const [appBundleData, setAppBundleData] = useState([]);
    const [bidFloorData, setBidFloorData] = useState({ minBidfloor: 0, maxBidfloor: 0, minTmax: 0, maxTmax: 0 });
    const [loading, setLoading] = useState(false);
    const [impTypeData, setImpTypeData] = useState([]);
    const [alignedData, setAlignedData] = useState([]);

    const fetchSupplyPanelDetails = async () => {
        setLoading(true);
        console.log("fetchSupplyPanelDetails called");

        try {
            // const startDate = '2024-06-30';
            // const endDate = '2024-07-01';
            const supplyId = selectedRowId;
            const url = `/report/supply/panel?startDate=${dates.startDate}&endDate=${dates.endDate}&supplyIds=${supplyId}`;
            console.log("Request URL:", url);
            const response = await getRequest(url, null, navigate);
            console.log("response :", response)
            if (response && response.supplyDeviceOsList) {
                setDeviceData(response.supplyDeviceOsList);
            }
            if (response && response.supplyGeoCountryList) {
                setGeoData(response.supplyGeoCountryList);
            }
            if (response && response.supplyAppBundleList) {
                setAppBundleData(response.supplyAppBundleList);
            }
            if (response && response.supplyBidFloorList && response.supplyBidFloorList.length > 0) {
                const bidFloor = response.supplyBidFloorList[0];
                setBidFloorData({
                    minBidfloor: bidFloor.minBidfloor.toFixed(2),
                    maxBidfloor: bidFloor.maxBidfloor.toFixed(2),
                    minTmax: bidFloor.minTmax,
                    maxTmax: bidFloor.maxTmax,
                });
            }
            if (response && response.supplyImpTypeList) {
                setImpTypeData(response.supplyImpTypeList);
            }
            if (response && response.routesAlignedAndDemandAlignedsList && response.routesAlignedAndDemandAlignedsList.length > 0) {
                setAlignedData(response.routesAlignedAndDemandAlignedsList[0]);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };


    const demandName = () => {
        return (
            <div>
                <div>{demandAlignment[0].name}</div>
            </div>
        )
    }

    const supplyName = () => {
        return (
            <div>
                <div>{supplyAlignment[0].name}</div>
            </div>
        )
    }
    const getColorForImpType = (impType) => {
        switch (impType) {
            case 'banner':
                return '#3498DB';
            case 'video':
                return '#2ECC71';
            case 'audio':
                return '#E74C3C';
            case 'native':
                return '#F1C40F';
            case 'pmp':
                return '#D9D9D9';
            default:
                return '#D9D9D9';
        }
    };

    const getVisualParts = (impTypeData) => {
        const defaultLegends = {
            video: { percentage: 0, color: "#2ECC71", legend: "Video" },
            banner: { percentage: 0, color: "#3498DB", legend: "Banner" },
            audio: { percentage: 0, color: "#E74C3C", legend: "Audio" },
            native: { percentage: 0, color: "#F1C40F", legend: "Native" },
            pmp: { percentage: 0, color: "#D9D9D9", legend: "PMP" }
        };

        impTypeData.forEach((imp) => {
            if (defaultLegends[imp.impType]) {
                defaultLegends[imp.impType].percentage = imp.percentage;
            }
        });

        return Object.values(defaultLegends).map((legend) => ({
            percentage: `${legend.percentage}%`,
            color: legend.color,
            legend: legend.legend,
        }));
    };


    return (

        <div>
            <Box>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" className='popupContent-tab-buttons'>
                    <Tab label="Details" {...a11yProps(0)} />
                    <Tab label={PerformanceLabel2} {...a11yProps(1)} />
                    <Tab label={PerformanceLabel1} {...a11yProps(2)} />
                </Tabs>
            </Box>

            <div>
                    <Box sx={{ width: '100%', padding: '1rem' }} className="popupContent">
            <CustomTabPanel value={value} index={1} className="customTabPanel">
                <Box>
                    <DataTable
                        value={demandAlignment} resizableColumns removableSort tableStyle={{ minWidth: '20rem' }}
                        paginator rows={10} rowsPerPageOptions={[5, 10, 25, 50]}
                        paginatorTemplate={paginatorTemplate}>
                        <Column field="demandName" header="Demand Name" body={(rowData) => <div>{rowData.name}</div>}></Column>
                        <Column field="opportunities" header="Opportunities" headerStyle={{ textAlign: 'center' }} alignHeader={'center'} bodyStyle={{ textAlign: 'center' }}></Column>
                        <Column field="demandRequests" header="Demand Requests" headerStyle={{ textAlign: 'center' }} alignHeader={'center'} bodyStyle={{ textAlign: 'center' }}></Column>
                        <Column field="impressions" header="Impressions" headerStyle={{ textAlign: 'center' }} alignHeader={'center'} bodyStyle={{ textAlign: 'center' }}></Column>
                    </DataTable>
                </Box>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2} className="customTabPanel">
                <Box>
                    <DataTable
                        value={supplyAlignment}
                        resizableColumns removableSort tableStyle={{ minWidth: '20rem' }}
                        paginator rows={10} rowsPerPageOptions={[5, 10, 25, 50]}
                        paginatorTemplate={paginatorTemplate}>
                        <Column field="supplyName" header="Supply Name" body={(rowData) => <div>{rowData.name}</div>}></Column>
                        <Column field="passthrough" header="Passthrough" headerStyle={{ textAlign: 'center' }} alignHeader={'center'} bodyStyle={{ textAlign: 'center' }}></Column>
                        <Column field="fillRate" header="Fill Rate" headerStyle={{ textAlign: 'center' }} alignHeader={'center'} bodyStyle={{ textAlign: 'center' }}></Column>
                        <Column field="eRPM" header="eRPM" headerStyle={{ textAlign: 'center' }} alignHeader={'center'} bodyStyle={{ textAlign: 'center' }}></Column>
                    </DataTable>
                </Box>
            </CustomTabPanel>
            
                
                        <CustomTabPanel value={value} index={0} className="customTabPanel">
                        {loading ? (
                <Loader />
            ) : (<div>
                            {/* <Box sx={{ minWidth: 0, flex: 1 }}>
                                <ProgressLine
                                    label="Impression Type"
                                    visualParts={[
                                        {
                                            percentage: "50%",
                                            color: "#2ECC71",
                                            legend: "Video"
                                        },
                                        {
                                            percentage: "20%",
                                            color: "#3498DB",
                                            legend: "Banner"
                                        },
                                        {
                                            percentage: "17%",
                                            color: "#E74C3C",
                                            legend: "Audio"
                                        },
                                        {
                                            percentage: "8%",
                                            color: "#F1C40F",
                                            legend: "Native"
                                        },
                                        {
                                            percentage: "5%",
                                            color: "#D9D9D9",
                                            legend: "PMP"
                                        }
                                    ]}
                                />
                            </Box> */}
                            <Box sx={{ minWidth: 0, flex: 1 }}>
                                <ProgressLine
                                    label="Impression Type"
                                    visualParts={getVisualParts(impTypeData)}
                                />
                            </Box>

                            <Box sx={{ minWidth: 0, flex: 1, padding: '1rem' }} className="form-group-border-top">
                                <Grid container spacing={2}>
                                    {/* <Grid item xs={6} md={6}>
                                        <Box sx={{ minWidth: 0, flex: 1 }}>
                                            <Typography level="title-sm" className='fs-1'>Ad Sizes</Typography>
                                        </Box>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6} md={6}>
                                                <Typography level="title-sm" className='fs-2'>Video</Typography>
                                                <Typography level="body-xs" className='fs-3'>300 x 250  -  <b>25%</b></Typography>
                                                <Typography level="body-xs" className='fs-3'>750 x 200  -  <b>15%</b></Typography>
                                                <Typography level="body-xs" className='fs-3'>400 x 300  -  <b>15%</b></Typography>
                                            </Grid>
                                            <Grid item xs={6} md={6}>
                                                <Typography level="title-sm" className='fs-2'>Banner</Typography>
                                                <Typography level="body-xs" className='fs-3'>300 x 250  -  <b>25%</b></Typography>
                                                <Typography level="body-xs" className='fs-3'>750 x 200  -  <b>15%</b></Typography>
                                                <Typography level="body-xs" className='fs-3'>400 x 300  -  <b>15%</b></Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid> */}
                                    <Grid item xs={3} md={3}>
                                        <Box sx={{ minWidth: 0, flex: 1 }}>
                                            <Typography level="title-sm" className='fs-1'>Routes Performance</Typography>
                                            <div className="demandsAlignedResult flex justify-content-center">{alignedData.routesAligned}</div>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={3} md={3}>
                                        <Box sx={{ minWidth: 0, flex: 1 }}>
                                            <Typography level="title-sm" className='fs-1'>Demands Aligned</Typography>
                                            <div className="demandsAlignedResult flex justify-content-center">{alignedData.demandsAligned}</div>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box sx={{ minWidth: 0, flex: 1, padding: '1rem' }} className="form-group-border-top">
                                <Grid container spacing={2}>
                                    <Grid item xs={6} md={6}>
                                        <Box sx={{ minWidth: 0, flex: 1 }}>
                                            <Typography level="title-sm" className='fs-1'>Bundle</Typography>
                                        </Box>
                                        <Grid container spacing={2}>
                                            <Grid item sx={{ width: '50%' }} className='bundle-grid'>
                                                <Box sx={{ minWidth: 0, flex: 1 }}>
                                                    <Typography level="title-sm" className='fs-2'>Video</Typography>
                                                    <Typography level="body-xs" className='fs-3'>No video request</Typography>
                                                    {/* <Typography level="body-xs" className='fs-3'>example.com</Typography>
                                                    <Typography level="body-xs" className='fs-3'>example.com</Typography>
                                                    <Typography level="body-xs" className='fs-3'>example.com</Typography>
                                                    <Typography level="body-xs" className='fs-3'>example.com</Typography>
                                                    <Typography level="body-xs" className='fs-3'>example.com</Typography>
                                                    <Typography level="body-xs" className='fs-3'>example.com</Typography>
                                                    <Typography level="body-xs" className='fs-3'>example.com</Typography>
                                                    <Typography level="body-xs" className='fs-3'>example.com</Typography>
                                                    <Typography level="body-xs" className='fs-3'>example.com</Typography>
                                                    <Typography level="body-xs" className='fs-3'>example.com</Typography>
                                                    <Typography level="body-xs" className='fs-3'>example.com</Typography> */}
                                                </Box>
                                                <Box sx={{ minWidth: 0, flex: 1 }}>
                                                    <Typography level="title-sm" className='fs-2'>Native</Typography>
                                                    <Typography level="body-xs" className='fs-3'>No native request</Typography>
                                                </Box>
                                            </Grid>
                                            <Grid item sx={{ width: '50%' }} className='bundle-grid'>
                                                <Box sx={{ minWidth: 0, flex: 1 }}>
                                                    <Typography level="title-sm" className='fs-2'>Banner</Typography>
                                                    {
                                                        appBundleData.length > 0 ? (
                                                            appBundleData.map((appBundle, index) => (
                                                                <Typography key={index} level="body-xs" className='fs-3' sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                    {appBundle.appBundle}
                                                                </Typography>
                                                            ))
                                                        ) : (
                                                            <Typography level="body-xs" className='fs-3'>
                                                                No Banner request
                                                            </Typography>
                                                        )
                                                    }
                                                    {/* <Typography level="body-xs" className='fs-3'>example.com</Typography>
                                        <Typography level="body-xs" className='fs-3'>example.com</Typography>
                                        <Typography level="body-xs" className='fs-3'>example.com</Typography> */}
                                                </Box>
                                                <Box sx={{ minWidth: 0, flex: 1 }}>
                                                    <Typography level="title-sm" className='fs-2'>Audio</Typography>
                                                    <Typography level="body-xs" className='fs-3'>no audio request</Typography>
                                                    {/* <Typography level="body-xs" className='fs-3'>example.com</Typography>
                                                    <Typography level="body-xs" className='fs-3'>example.com</Typography>
                                                    <Typography level="body-xs" className='fs-3'>example.com</Typography> */}
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={3} md={3}>
                                        <Box sx={{ minWidth: 0, flex: 1 }}>
                                            <Typography level="title-sm" className='fs-1'>Bidfloor</Typography>
                                            <table className='minMax-table'>
                                                <thead>
                                                    <tr>
                                                        <th>Min</th>
                                                        <th>Max</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>{bidFloorData.minBidfloor}</td>
                                                        <td>{bidFloorData.maxBidfloor}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            {/* <Stack sx={{ margin: '1.5rem 0', padding: '0 0.7rem' }} spacing={1} direction="row" className='bidfloor'>
                                                <Typography className='slider-min-label' sx={{ display: 'flex', margin: '-20px -20px 0px 0px' }} id="track-inverted-slider-min" gutterBottom>
                                                    Min
                                                </Typography>
                                                <Slider
                                                    aria-label="Bidfloor"
                                                    // defaultValue={bidFloorData.minTmax}
                                                    marks={[
                                                        { value: bidFloorData.minBidfloor, label: `Min: ${bidFloorData.minBidfloor}` },
                                                        { value: bidFloorData.maxBidfloor, label: `Max: ${bidFloorData.maxBidfloor}` }
                                                    ]}
                                                    track={false}
                                                    min={bidFloorData.minBidfloor}
                                                    max={bidFloorData.maxBidfloor}
                                                />
                                                <Typography className='slider-max-label' sx={{ display: 'flex', margin: '-20px 0px 0px -20px' }} id="track-inverted-slider-max" gutterBottom>
                                                    Max
                                                </Typography>
                                            </Stack> */}
                                        </Box>
                                        <Box sx={{ minWidth: 0, flex: 1 }}>
                                            <Typography level="title-sm" className='fs-1'>Tmax</Typography>
                                            <table className='minMax-table'>
                                                <thead>
                                                    <tr>
                                                        <th>Min</th>
                                                        <th>Max</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>{bidFloorData.minTmax}</td>
                                                        <td>{bidFloorData.maxTmax}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            {/* <Stack sx={{ margin: '1.5rem 0', padding: '0 0.7rem' }} spacing={1} direction="row">
                                                <Typography className='slider-min-label' sx={{ display: 'flex', margin: '-20px -20px 0px 0px' }} id="track-inverted-slider-min" gutterBottom>
                                                    Min
                                                </Typography>
                                                <Slider
                                                    aria-label="Temperature"
                                                    // defaultValue={30}
                                                    marks={[
                                                        { value: bidFloorData.minTmax, label: `Min: ${bidFloorData.minTmax}` },
                                                        { value: bidFloorData.maxTmax, label: `Max: ${bidFloorData.maxTmax}` }
                                                    ]}
                                                    track={false}
                                                    min={bidFloorData.minTmax}
                                                    max={bidFloorData.maxTmax}
                                                ></Slider>
                                                <Typography className='slider-max-label' sx={{ display: 'flex', margin: '-20px 0px 0px -20px' }} id="track-inverted-slider-max" gutterBottom>
                                                    Max
                                                </Typography>
                                            </Stack> */}
                                        </Box>
                                        {/* <Box sx={{ minWidth: 0, flex: 1 }}>
                                            <Typography level="title-sm" className='fs-1'>Schain</Typography>
                                            <DataTable className='data-table-no-normal' resizableColumns value={schain}> 
                                            </DataTable>
                                        </Box> */}
                                    </Grid>
                                    <Grid item xs={3} md={3}>
                                        <Box sx={{ minWidth: 0, flex: 1 }}>
                                            <Typography level="title-sm" className='fs-1' >Geo</Typography>
                                            {geoData.map((geo, index) => (
                                                <Typography key={index} level="body-xs" className='fs-3' sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    {geo.geoCountry} <b>{geo.percentage}%</b>
                                                </Typography>
                                            ))}
                                            {/* <Typography level="body-xs" className='fs-3' sx={{ display: 'flex', justifyContent: 'space-between' }}>US  <b>64%</b></Typography>
                                <Typography level="body-xs" className='fs-3' sx={{ display: 'flex', justifyContent: 'space-between' }}>UK  <b>14%</b></Typography>
                                <Typography level="body-xs" className='fs-3' sx={{ display: 'flex', justifyContent: 'space-between' }}>Germany  <b>12%</b></Typography>
                                <Typography level="body-xs" className='fs-3' sx={{ display: 'flex', justifyContent: 'space-between' }}>Australia  <b>10%</b></Typography> */}
                                        </Box>
                                        <Box sx={{ minWidth: 0, flex: 1 }}>
                                            <Typography level="title-sm" className='fs-1'>Device OS</Typography>
                                            {deviceData.map((device, index) => (
                                                <Typography key={index} level="body-xs" className='fs-3' sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    {device.deviceOs} <b>{device.percentage}%</b>
                                                </Typography>
                                            ))}
                                        </Box>
                                        {/* <Box sx={{ minWidth: 0, flex: 1 }}>
                                            <Typography level="title-sm" className='fs-1' >Regulations</Typography> 
                                        </Box> */}
                                    </Grid>
                                </Grid>
                            </Box>
                            </div>
            )}
                        </CustomTabPanel>
</Box>
                </div>
                
            

        </div>
    );
}